import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

function InitHelmet() {
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const { objectId: orgId } = useSelector(store => store.organization);

  const isCyberbizConnect = pathname === `/cyberbiz/${orgId}/connect`;
  const isCyberbizOrderPage = pathname === `/cyberbiz/${orgId}/order`;
  const isShopifyConnect = pathname === `/shopify/${orgId}/connect`;
  const isShopifyOrderPage = pathname === `/shopify/${orgId}/order`;
  const isShoplineConnect = pathname === `/shopline/${orgId}/connect`;
  const isShoplineOrderPage = pathname === `/shopline/${orgId}/order`;
  const isMitakeConnect = pathname === `/mitake/${orgId}/connect`;

  if (isMitakeConnect) {
    return (
      <Helmet>
        <title>{t('mitake:header')}</title>
      </Helmet>
    );
  }

  if (~pathname.indexOf('/gssVital/')) {
    return (
      <Helmet>
        <title>{t('gssVital:title')}</title>
      </Helmet>
    );
  }

  if (~pathname.indexOf('shopline')) {
    if (isShoplineConnect) {
      return (
        <Helmet>
          <title>{t('ecBinding:shopline-connect-title')}</title>
        </Helmet>
      );
    }

    if (isShoplineOrderPage) {
      return (
        <Helmet>
          <title>{t('ecBinding:shopline-order-title')}</title>
        </Helmet>
      );
    }

    return (
      <Helmet>
        <title>{t('ecBinding:shopline-title')}</title>
      </Helmet>
    );
  }

  if (~pathname.indexOf('shopify')) {
    if (isShopifyConnect) {
      return (
        <Helmet>
          <title>{t('ecBinding:shopify-connect-title')}</title>
        </Helmet>
      );
    }

    if (isShopifyOrderPage) {
      return (
        <Helmet>
          <title>{t('ecBinding:shopify-order-title')}</title>
        </Helmet>
      );
    }

    return (
      <Helmet>
        <title>{t('ecBinding:shopify-title')}</title>
      </Helmet>
    );
  }

  if (~pathname.indexOf('cyberbiz')) {
    if (isCyberbizConnect) {
      return (
        <Helmet>
          <title>{t('ecBinding:cyberbiz-connect-title')}</title>
        </Helmet>
      );
    }

    if (isCyberbizOrderPage) {
      return (
        <Helmet>
          <title>{t('ecBinding:cyberbiz-order-title')}</title>
        </Helmet>
      );
    }

    return (
      <Helmet>
        <title>{t('ecBinding:cyberbiz-title')}</title>
      </Helmet>
    );
  }

  if (~pathname.indexOf('aiBot')) {
    return (
      <Helmet>
        <title>{t('aiBot:title')}</title>
      </Helmet>
    );
  }

  if (~pathname.indexOf('recurringMessage')) {
    return (
      <Helmet>
        <title>{t('recurringMessage:title')}</title>
      </Helmet>
    );
  }

  if (~pathname.indexOf('error')) {
    return (
      <Helmet>
        <title>{t('errorPageTitle')}</title>
      </Helmet>
    );
  }

  if (~pathname.indexOf('liff-redirect')) {
    return (
      <Helmet>
        <title>{t('liffRedirectTitle')}</title>
      </Helmet>
    );
  }

  return (
    <Helmet>
      <title>{t('defaultPageTitle')}</title>
    </Helmet>
  );
}

export default InitHelmet;
